import { toastError } from '@app/components/Toastify';
import { useCompanyId } from '@app/hooks/general/useCompanyId';
import { useCreateSheinStoreMutation } from '@app/pages/redirection/hooks/useCreateSheinStoreMutation';
import { RouteToDestinations } from '@app/types/angular';
import { angularRouteTo } from '@app/utils/angular';
import React, { useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';

export function SheinRedirectionPage() {
  const { formatMessage } = useIntl();
  const { mutateAsync: sheinCreateStoreMutateAsync } = useCreateSheinStoreMutation();
  const companyId = useCompanyId();

  const processShein = useCallback(async () => {
    const params = new URLSearchParams(window.location.search);
    const appid = params.get('appid');
    const tempToken = params.get('tempToken');
    const state = params.get('state');

    if (!appid || !tempToken || !state) {
      toastError(formatMessage({ id: 'connect.notifications.auth-failed' }));
      angularRouteTo(RouteToDestinations.Connect);
      return;
    }

    if (companyId) {
      try {
        const store = await sheinCreateStoreMutateAsync({ appid, tempToken, state });
        if (store) {
          angularRouteTo(RouteToDestinations.Single_Store, {
            id: store.id,
            store,
          });
        }
      } catch (e) {
        toastError(e.response?.data.message);
        setTimeout(() => {
          angularRouteTo(RouteToDestinations.Connect);
        }, 1000);
      }
    }
  }, [formatMessage, sheinCreateStoreMutateAsync, companyId]);

  useEffect(() => {
    processShein();
  }, [processShein]);
  return null;
}
